import { http } from '@/api/index';

export const activateWebsiteAuth = (organizationId: string) => {
  return http.post('/website/auth/activate', {
    organizationId,
  });
}

export const disableWebsiteAuth = (organizationId: string) => {
  return http.post('/website/auth/disable', {
    organizationId,
  });
}
